module.exports = __webpack_public_path__ + "static/hero-image-ecaf54b0cfd12a41e85ff0f078743bcd.png";